// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  reservation: {
    name: 'reservation',
    componentName: 'Reservation',
    chunk: () => import(
      /* webpackChunkName: "reservation" */
      './pages/Reservation'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Reservation.js')).Reservation
        : currentRouteName === 'reservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Reservation })));
    },
    path: '/:context?/p/rental/reservations/:slug?/:itemId',
    channel: null
  },
  selfDropoff: {
    name: 'selfDropoff',
    componentName: 'SelfDropoff',
    chunk: () => import(
      /* webpackChunkName: "selfDropoff" */
      './pages/SelfDropoff'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SelfDropoff.js')).SelfDropoff
        : currentRouteName === 'selfDropoff'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SelfDropoff })));
    },
    path: '/:context?/rental/self-dropoff/:storeId',
    channel: null
  },
  reservationDetails: { // TODO: Remove once transitioned off
    name: 'reservationDetails',
    componentName: 'ReservationDetails',
    chunk: () => import(
      /* webpackChunkName: "reservationDetails" */
      './pages/ReservationDetails'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ReservationDetails.js')).ReservationDetails
        : currentRouteName === 'reservationDetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReservationDetails })));
    },
    path: '/:context?/p/rental/reservationDetails',
    channel: null
  },
  cancelReservation: {
    name: 'cancelReservation',
    componentName: 'CancelReservation',
    chunk: () => import(
      /* webpackChunkName: "cancelReservation" */
      './pages/CancelReservation'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/CancelReservation.js')).CancelReservation
        : currentRouteName === 'cancelReservation'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.CancelReservation }))
          );
    },
    path: '/:context?/rental/cancel-reservation/:cancellationId/:reservationNumber',
    channel: null
  },
  product: {
    name: 'product',
    componentName: 'Product',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/Product'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Product.js')).Product
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Product })));
    },
    path: '/:context?/p/rental/:slug?/:itemId',
    channel: null
  },

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
